import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Typography } from '@material-ui/core';
export const SingleValue = props => /*#__PURE__*/React.createElement(Typography, _extends({
  className: props.selectProps.classes.singleValue,
  style: {
    minWidth: 'fit-content'
  }
}, props.innerProps), props.children);